import { render, staticRenderFns } from "./DataMonthOweStatistics.vue?vue&type=template&id=0f171a51&scoped=true"
import script from "./DataMonthOweStatistics.vue?vue&type=script&lang=js"
export * from "./DataMonthOweStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataMonthOweStatistics.vue?vue&type=style&index=0&id=0f171a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f171a51",
  null
  
)

export default component.exports